var _g, _polygon, _polygon2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_2",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 909.56 894.38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.94,
    y1: 16.2,
    x2: 571.93,
    y2: 16.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 770.24,
    y1: 130.69,
    x2: 571.93,
    y2: 16.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 770.24,
    y1: 130.69,
    x2: 884.74,
    y2: 329.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 884.74,
    y1: 329.01,
    x2: 884.74,
    y2: 558
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 770.24,
    y1: 756.31,
    x2: 884.74,
    y2: 558
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 571.93,
    y1: 870.81,
    x2: 770.24,
    y2: 756.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.94,
    y1: 870.81,
    x2: 571.93,
    y2: 870.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 144.62,
    y1: 756.31,
    x2: 342.94,
    y2: 870.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 30.13,
    y1: 558,
    x2: 144.62,
    y2: 756.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 30.13,
    y1: 329.01,
    x2: 30.13,
    y2: 558
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 144.62,
    y1: 130.69,
    x2: 30.13,
    y2: 329.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.94,
    y1: 16.2,
    x2: 144.62,
    y2: 130.69
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "572.65,13.52 342.22,13.52 142.66,128.73 27.45,328.29 27.45,558.72 142.66,758.27 342.22,873.49  572.65,873.49 772.2,758.27 887.42,558.72 887.42,328.29 772.2,128.73 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "571.25,18.75 343.62,18.75 146.49,132.56 32.68,329.69 32.68,557.32 146.49,754.45 343.62,868.26  571.25,868.26 768.37,754.45 882.19,557.32 882.19,329.69 768.37,132.56 "
  })));
};

export default __webpack_public_path__ + "static/media/inner.6f4dcd5e.svg";
export { SvgComponent as ReactComponent };